import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { GRAPHQL_ENDPOINT } from 'constants/config'
import { auth } from 'firebase/index'

const httpLink = createHttpLink({ uri: GRAPHQL_ENDPOINT })

const authLink = setContext(async (_, { headers }) => {
  const currentUser = auth.currentUser
  if (!currentUser) throw new Error('This device has not been authenticated')
  const token = await currentUser.getIdToken(true)
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  }
})

export const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
})
